import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_detailService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, AllocatedPackagedAmount?: number, AvailablePackagedAmount?: number, ExpirationDate?: string, InactivePackagedAmount?: number, IncomingPackagedAmount?: number, TotalPackagedAmount?: number, LicensePlateStatus?: { Name?: string }, Location?: { Name?: string }, Material?: { Description?: string, Name?: string, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string }, LicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number, TasksForActualTargetLicensePlate?: { Id?: number, Order?: { LookupCode?: string, OwnerReference?: string } }[] }, Lot?: { ReceiveDate?: string }, orderLookup?: string, orderOwnerReference?: string }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, AllocatedPackagedAmount?: number, AvailablePackagedAmount?: number, ExpirationDate?: string, InactivePackagedAmount?: number, IncomingPackagedAmount?: number, TotalPackagedAmount?: number, LicensePlateStatus?: { Name?: string }, Location?: { Name?: string }, Material?: { Description?: string, Name?: string, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string }, LicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number, TasksForActualTargetLicensePlate?: { Id?: number, Order?: { LookupCode?: string, OwnerReference?: string } }[] }, Lot?: { ReceiveDate?: string }, orderLookup?: string, orderOwnerReference?: string }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId?: number, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, AllocatedPackagedAmount?: number, AvailablePackagedAmount?: number, ExpirationDate?: string, InactivePackagedAmount?: number, IncomingPackagedAmount?: number, TotalPackagedAmount?: number, LicensePlateStatus?: { Name?: string }, Location?: { Name?: string }, Material?: { Description?: string, Name?: string, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string }, LicensePlate?: { GrossWeight?: number, LookupCode?: string, NetWeight?: number, TasksForActualTargetLicensePlate?: { Id?: number, Order?: { LookupCode?: string, OwnerReference?: string } }[] }, Lot?: { ReceiveDate?: string }, orderLookup?: string, orderOwnerReference?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId?: number    }) {
      return false;
    }
}
